import type { DialogBodyProps, DialogContentProps, DialogRootProps } from '@chakra-ui/react'
import { Dialog, Portal, CloseButton } from '@chakra-ui/react'
import { FC, ReactNode } from 'react'

type Props = {
  title: ReactNode
  body: ReactNode
  footer?: ReactNode
  showCloseButton?: boolean
  modalProps?: Omit<DialogRootProps, 'children' | 'onOpen' | 'onClose' | 'isOpen'>
  modalContentProps?: DialogContentProps
  modalBodyProps?: DialogBodyProps
  trigger?: ReactNode
}
export const BaseModal: FC<Props> = ({
  modalProps,
  modalBodyProps,
  modalContentProps,
  showCloseButton = true,
  trigger,
  title,
  body,
  footer,
}) => {
  return (
    <>
      <Dialog.Root size={'sm'} {...modalProps} lazyMount={true} unmountOnExit={true}>
        <Dialog.Trigger asChild>{trigger ?? <span />}</Dialog.Trigger>
        <Portal>
          <Dialog.Backdrop />
          <Dialog.Positioner>
            <Dialog.Content height={'fit-content'} minHeight={'fit-content'} {...modalContentProps}>
              <Dialog.Header fontSize={'2xl'}>{title}</Dialog.Header>
              <Dialog.Body height={'fit-content'} pb={7} {...modalBodyProps}>
                {body}
              </Dialog.Body>
              {footer && <Dialog.Footer>{footer}</Dialog.Footer>}

              {showCloseButton ? (
                <Dialog.CloseTrigger asChild>
                  <CloseButton size="sm" />
                </Dialog.CloseTrigger>
              ) : null}
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </>
  )
}
